import { useQuery } from '@apollo/react-hooks';
import { useLocation } from 'react-router-dom';
import articleDetailQuery from '../pages/Article/query';

const useArticleEntry = () => {
  const location = useLocation();
  const locationParts = location.pathname.substr(1).split('/');
  const DECODE_CARDS_QUERY = articleDetailQuery(locationParts[2]);
  const { data = {}, loading } = useQuery(DECODE_CARDS_QUERY);

  if (loading) {
    return { decodeArticleCards: [], loaded: false };
  }

  if (data && data?.entry) {
    return {
      ...data.entry,
      loaded: true
    };
  }
  throw new Error('No Entry');
};
export default useArticleEntry;
